import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ModalidadeGarantia } from "./modalidade_garantia.model";

export class ParametroConsultaImpedimento extends BaseEntity {
    
    public ide ?: number;
    public quantidadeMaximaMensal ?: number;
    public quantidadeMaximaDiaria ?: number;
    public dataCriacao ?: Date;
    public dataUltimaAtualizacao ?: Date;
    public modalidadeDTO ?: ModalidadeGarantia;
  
}
